import { html, unsafeCSS } from 'lit';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './optional.styles';

export class OptionalWrapper extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    override render() {
        return html`
            <div class="o-module__optional">
                <slot></slot>
            </div>
        `;
    }
}
